import { BaseBus } from "./BaseBus";
import { GeographyInfoBus } from "./GeographyInfoBus";

export class PotentialCustomerBus extends BaseBus {

    constructor(data: PotentialCustomerBus) {
        super(data);
    }

    potentialCustomerId: string;
    companyId: string;
    potentialCustomerName: string;
    firstName: string;
    lastName: string;
    isActive: boolean;
    quickSearchKey: string;
    emailAddress: string;
    workNumber: string;
    mobileNumber: string;
    faxNumber: string;
    notes: string;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    workExt: string;

    geographyInfo: GeographyInfoBus;
}
